enum ExpenseStatus {
	TO_SUBMIT = "TO_SUBMIT", 
    SUBMITTED = "SUBMITTED", 
    APPROVED = "APPROVED", 
    REJECTED = "REJECTED", 
    TO_REIMBURSE = "TO_REIMBURSE", 
    REIMBURSED = "REIMBURSED"
}

export default ExpenseStatus;